<template>
  <div class="customer-form p-0">
    <form @submit.prevent="submitForm" class="">
      <div class="form-group">
        <label>First name *</label>
        <input
          type="text"
          v-model="formData.first_name"
          required
          class="form-input"
        />
      </div>

      <div class="form-group">
        <label>Last name *</label>
        <input
          type="text"
          v-model="formData.last_name"
          required
          class="form-input"
        />
      </div>

      <div class="form-group">
        <label>Email *</label>
        <input
          type="email"
          v-model="formData.email"
          required
          class="form-input"
        />
      </div>

      <div class="form-group">
        <label>Street *</label>
        <input
          type="text"
          v-model="formData.street"
          required
          class="form-input"
        />
      </div>

      <div class="form-group">
        <label>City *</label>
        <input
          type="text"
          v-model="formData.city"
          required
          class="form-input"
        />
      </div>

      <div class="form-group">
        <label>Country *</label>
        <select
          v-model="formData.country_id"
          class="form-select"
        >
          <option value="">Select Country</option>
          <option v-for="country in countries" :key="country.id" :value="country.id">
            {{ country.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label>State *</label>
          <input
            v-if="formData.country_id != '244'"
            type="text"
            v-model="formData.state"
            required
            class="form-input"
          />
          <select v-else  v-model="formData.state" required class="form-select">
            <option value="">Select State</option>
            <option v-for="state in states" :key="state" :value="state">
              {{ state }}
            </option>
          </select>
      </div>

      <div class="form-group">
        <label>Zipcode *</label>
        <input
          type="text"
          v-model="formData.zib_code"
          required
          class="form-input"
        />
      </div>

      <div class="form-group">
        <label>Phone *</label>
        <input
          type="tel"
          v-model="formData.phone"
          required
          class="form-input"
        />
      </div>
    </form>

    <div class="form-footer">
      <div class="shipping-info">
        <p>
          You will receive a confirmation email including instructions on
          shipping your banknote.
        </p>
        <p>
          You will receive an additional email with a pre-paid
          <strong>FEDEX Priority Overnight</strong> shipping label.
        </p>
      </div>

      <div class="terms-section">
        <label class="terms-checkbox">
          <input type="checkbox" v-model="formData.termsAccepted" required />
          I have read and accept the
          <a target="_blank" href="https://www.100trillions.com/terms-and-conditions">
            Terms &amp; Conditions
          </a>
        </label>
      </div>

      <button
        @click="submitForm"
        class="submit-btn"
        :disabled="fullfilled || loading"
      >
        <span v-if="loading">Please wait..</span>
        <span v-else>CREATE SELL REQUEST</span>
      </button>

      <p class="error-message" v-if="totalValue <= 0">
        The Total Value must be greater than zero.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SellForm",
  props: {
    totalValue: {
      type: Number,
      required: true,
    },
    countries: {
      required: true,
    },
    states: {
      required: true,
    },
    rows: []
  },
  data() {
    return {
      loading: false,
      formData: {
        first_name: "",
        last_name: "",
        email: "",
        street: "",
        city: "",
        country_id: "",
        state: "",
        zib_code: "",
        phone: "",
        termsAccepted: false,
      },
    };
  },
  computed: {
    fullfilled() {
      console.log("rows are")
      console.log(this.rows)
      console.log(this.rows.length == 5)
      if (this.totalValue <= 0 || !this.formData.termsAccepted)
        return true;
      console.log(this.formData)
      if (this.formData.first_name == "" || this.formData.last_name == "" || this.formData.email == "" || this.formData.street == "" || this.formData.state == "" || this.formData.country_id == "" || this.formData.zip_code == "" || this.formData.phone == "")
        return true;

      console.log(this.rows[0].files)
      return this.rows.find(row => (row.type == '' || row.customer_price == 0 || row.customer_quantity == 0 || row.country == "" || row.condition_id == undefined || row.condition_id == "" || row.country_id == "" || row.country_id == "" || row.country_id == undefined));
    },
  },
  methods: {
    showTerms() {
      console.log("Show terms and conditions");
    },
    submitForm() {
      if (this.totalValue <= 0) {
        return;
      }
      console.log("Form submitted:", this.formData);
      console.log("form rows data:", this.rows)


      this.formData['sellToUsOrderProducts'] = this.rows

      this.loading = true

      $.ajax({
        method: "POST",
        url: route("sell-to-us.submit"),
        data: this.formData,
      })
        .then(() => {
          this.loading = false
          this.$successNotify("Thank you for your Sell to us request")
          window.location.href = ""
        })
        .catch((xhr) => {
          this.placingOrder = false
          this.loadingOrderSummary = false
          this.loading = false
          this.$errorNotify(xhr.responseJSON.message)
        })
    },
  },
};
</script>

<style scoped>
.customer-form {
  background: white;
  padding: 30px;
  margin-top: 30px;
  border-radius: 8px;
  max-width: 600px;
  margin-bottom: 100px;
}

.customer-form h2 {
  margin-bottom: 20px;
  color: #333;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
}

.form-input,
.form-select {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-footer {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.shipping-info {
  margin-bottom: 20px;
}

.shipping-info p {
  margin: 10px 0;
  color: #666;
}

.terms-section {
  margin: 20px 0;
}

.terms-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
}

.terms-checkbox a {
  color: var(--color-default);
  text-decoration: none;
}

.submit-btn {
  background-color: var(--color-default);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  margin-top: 20px;
}

.submit-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.error-message {
  color: #ff4444;
  margin-top: 10px;
  text-align: center;
}
</style>
